import * as React from "react";
const shortDateTime = new Intl.DateTimeFormat("de", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
});
const longDateTime = new Intl.DateTimeFormat("de", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
    weekday: "long",
});
const minuteInMs = 60 * 1000;
const hourInMs = 60 * minuteInMs;
const dayInMs = 24 * hourInMs;
function isSameCalendarDay(left, right) {
    return (left.getFullYear() === right.getFullYear() &&
        left.getMonth() === right.getMonth() &&
        left.getDate() === right.getDate());
}
function getAbsoluteLabel(date, onlyDate) {
    const absolute = shortDateTime.format(date);
    if (onlyDate) {
        return absolute.substring(0, absolute.indexOf(","));
    }
    return absolute;
}
function getRelativeDateLabel(date, now) {
    if (isSameCalendarDay(date, now)) {
        return "heute";
    }
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (isSameCalendarDay(date, yesterday)) {
        return "gestern";
    }
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    if (isSameCalendarDay(date, tomorrow)) {
        return "morgen";
    }
    return undefined;
}
function getRelativeDateTimeLabel(date, now) {
    const diffInMs = now.getTime() - date.getTime();
    if (diffInMs < 0) {
        return undefined;
    }
    if (diffInMs <= minuteInMs) {
        return "gerade eben";
    }
    if (diffInMs <= 90 * minuteInMs) {
        return `vor ${Math.floor(diffInMs / minuteInMs)} min`;
    }
    if (diffInMs <= dayInMs) {
        return `vor ${Math.floor(diffInMs / hourInMs)} h`;
    }
    return undefined;
}
export const DateTime = ({ value, onlyDate, onlyAbsolute }) => {
    const [short, long] = React.useMemo(() => {
        var _a, _b;
        const date = new Date(value);
        const now = new Date();
        const absolute = getAbsoluteLabel(date, onlyDate);
        if (onlyAbsolute) {
            return [absolute, longDateTime.format(date)];
        }
        if (onlyDate) {
            return [(_a = getRelativeDateLabel(date, now)) !== null && _a !== void 0 ? _a : absolute, longDateTime.format(date)];
        }
        return [(_b = getRelativeDateTimeLabel(date, now)) !== null && _b !== void 0 ? _b : absolute, longDateTime.format(date)];
    }, [value, onlyDate, onlyAbsolute]);
    return React.createElement("span", { title: long }, short);
};
//# sourceMappingURL=DateTime.js.map